import type { captureException, Event, Scope } from '@sentry/browser';

import { PRODUCT_BUILD } from '../../constants/build';
import { getEnvironment } from '../environment';

import { SENTRY_DSN, UNKNOWN_TAG } from './constants';

type SentryClient = {
	withScope(callback: (scope: Scope) => void): void;
	captureException: typeof captureException;
};

let Sentry: Promise<SentryClient | void> | undefined;

const beforeSend = (event: Event) => {
	// Delete the query string as it contains UGC
	if (event.request?.url) {
		event.request.url = event.request.url.split('?')[0];
	}

	if (event.request?.headers?.Referer) {
		event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
	}

	if (event.environment === 'development') {
		return null;
	}
	return event;
};

export const getSentryClient = async () => {
	if (!Sentry) {
		Sentry = import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/search-ai/sentry" */ '@sentry/browser'
		)
			.then((SentryModule) => {
				SentryModule.init({
					dsn: SENTRY_DSN,
					attachStacktrace: true,
					release: PRODUCT_BUILD || UNKNOWN_TAG,
					environment: getEnvironment(),
					beforeSend,
				});

				return SentryModule;
			})
			.catch(() => {
				// TODO: Retry mechanism for chunk loading failures?
			});
	}

	return Sentry;
};
